import { RecurlyCardType } from '@on3/api/src';
import { Amex } from '@on3/ui-lib/components/CreditCard/Badge/Amex';
import { Discover } from '@on3/ui-lib/components/CreditCard/Badge/Discover';
import { GenericCard } from '@on3/ui-lib/components/CreditCard/Badge/GenericCard';
import { MasterCard } from '@on3/ui-lib/components/CreditCard/Badge/MasterCard';
import { Visa } from '@on3/ui-lib/components/CreditCard/Badge/Visa';
import { type FC } from 'react';

import styles from './CreditCardBadge.module.scss';

interface CreditCardBadgeProps {
  type?: RecurlyCardType;
}

type CardComponent = FC;

const types: Partial<Record<RecurlyCardType, CardComponent>> = {
  [RecurlyCardType.Visa]: Visa,
  [RecurlyCardType.Mastercard]: MasterCard,
  [RecurlyCardType.AmericanExpress]: Amex,
  [RecurlyCardType.Discover]: Discover,
};

export const CreditCardBadge = ({ type }: CreditCardBadgeProps) => {
  const CardComponent = type && types[type] ? types[type]! : GenericCard;

  return (
    <span className={styles.badge}>
      <CardComponent />
    </span>
  );
};
